import { render, staticRenderFns } from "./PluginModal.vue?vue&type=template&id=57e3bc85&scoped=true&"
import script from "./PluginModal.vue?vue&type=script&lang=js&"
export * from "./PluginModal.vue?vue&type=script&lang=js&"
import style0 from "./PluginModal.vue?vue&type=style&index=0&id=57e3bc85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e3bc85",
  null
  
)

export default component.exports